export const CSS_CLASSES = {
  BUTTON_ROOT: "button",
  BUTTON_LITE_ROOT: "button-lite",

  BUTTON_LABEL_TEXT: "button-label-text",

  BUTTON_WIDTH_FULL: "button-width-full",

  BUTTON_LABEL_ALIGN_LEFT: "button-label-align-left",
  BUTTON_LABEL_ALIGN_CENTER: "button-label-align-center",
  BUTTON_LABEL_ALIGN_RIGHT: "button-label-align-right",
  BUTTON_LABEL_ALIGN_JUSTIFIED: "button-label-align-justified",

  BUTTON_LOADING: "button-loading",
  BUTTON_LOADING_SPINNER_ONLY: "button-loading-spinner-only",
  BUTTON_LOADING_BAR: "button-loading-bar",

  BUTTON_OUTLINED: "button-outlined",
  BUTTON_GHOST: "button-ghost",

  BUTTON_INTERACTIVE: "button-interactive",
  BUTTON_PRIMARY: "button-primary",
  BUTTON_SECONDARY: "button-secondary",
  BUTTON_ACCENT: "button-accent",
  BUTTON_GRAY: "button-gray",
  BUTTON_ERROR: "button-error",
  BUTTON_WARNING: "button-warning",
  BUTTON_SUCCESS: "button-success",
  BUTTON_WHITE: "button-white",

  BUTTON_MEDIUM: "button-medium",
  BUTTON_SMALL: "button-small",

  BUTTON_SQUARE: "button-square",
  BUTTON_PILL: "button-pill",

  BUTTON_OUTLINED_MEDIUM: "button-outlined-medium",
  BUTTON_GHOST_MEDIUM: "button-ghost-medium",
  BUTTON_OUTLINED_SMALL: "button-outlined-small",
  BUTTON_GHOST_SMALL: "button-ghost-small",

  BUTTON_FILLED_LARGE_FORCED_NORMAL: "button-filled-large-normal",
  BUTTON_FILLED_LARGE_FORCED_HOVER: "button-filled-large-hover",
  BUTTON_FILLED_LARGE_FORCED_FOCUS: "button-filled-large-focus",
  BUTTON_FILLED_LARGE_FORCED_ACTIVE: "button-filled-large-active",
  BUTTON_FILLED_MEDIUM_FORCED_NORMAL: "button-filled-medium-normal",
  BUTTON_FILLED_MEDIUM_FORCED_HOVER: "button-filled-medium-hover",
  BUTTON_FILLED_MEDIUM_FORCED_FOCUS: "button-filled-medium-focus",
  BUTTON_FILLED_MEDIUM_FORCED_ACTIVE: "button-filled-medium-active",
  BUTTON_FILLED_SMALL_FORCED_NORMAL: "button-filled-small-normal",
  BUTTON_FILLED_SMALL_FORCED_HOVER: "button-filled-small-hover",
  BUTTON_FILLED_SMALL_FORCED_FOCUS: "button-filled-small-focus",
  BUTTON_FILLED_SMALL_FORCED_ACTIVE: "button-filled-small-active",
  BUTTON_OUTLINED_LARGE_FORCED_NORMAL: "button-outlined-large-normal",
  BUTTON_OUTLINED_LARGE_FORCED_HOVER: "button-outlined-large-hover",
  BUTTON_OUTLINED_LARGE_FORCED_FOCUS: "button-outlined-large-focus",
  BUTTON_OUTLINED_LARGE_FORCED_ACTIVE: "button-outlined-large-active",
  BUTTON_OUTLINED_MEDIUM_FORCED_NORMAL: "button-outlined-medium-normal",
  BUTTON_OUTLINED_MEDIUM_FORCED_HOVER: "button-outlined-medium-hover",
  BUTTON_OUTLINED_MEDIUM_FORCED_FOCUS: "button-outlined-medium-focus",
  BUTTON_OUTLINED_MEDIUM_FORCED_ACTIVE: "button-outlined-medium-active",
  BUTTON_OUTLINED_SMALL_FORCED_NORMAL: "button-outlined-small-normal",
  BUTTON_OUTLINED_SMALL_FORCED_HOVER: "button-outlined-small-hover",
  BUTTON_OUTLINED_SMALL_FORCED_FOCUS: "button-outlined-small-focus",
  BUTTON_OUTLINED_SMALL_FORCED_ACTIVE: "button-outlined-small-active",
  BUTTON_GHOST_LARGE_FORCED_NORMAL: "button-ghost-large-normal",
  BUTTON_GHOST_LARGE_FORCED_HOVER: "button-ghost-large-hover",
  BUTTON_GHOST_LARGE_FORCED_FOCUS: "button-ghost-large-focus",
  BUTTON_GHOST_LARGE_FORCED_ACTIVE: "button-ghost-large-active",
  BUTTON_GHOST_MEDIUM_FORCED_NORMAL: "button-ghost-medium-normal",
  BUTTON_GHOST_MEDIUM_FORCED_HOVER: "button-ghost-medium-hover",
  BUTTON_GHOST_MEDIUM_FORCED_FOCUS: "button-ghost-medium-focus",
  BUTTON_GHOST_MEDIUM_FORCED_ACTIVE: "button-ghost-medium-active",
  BUTTON_GHOST_SMALL_FORCED_NORMAL: "button-ghost-small-normal",
  BUTTON_GHOST_SMALL_FORCED_HOVER: "button-ghost-small-hover",
  BUTTON_GHOST_SMALL_FORCED_FOCUS: "button-ghost-small-focus",
  BUTTON_GHOST_SMALL_FORCED_ACTIVE: "button-ghost-small-active",

  // ------------------------------------------------
  BUTTON_INTERACTIVE_NORMAL: "button-interactive-normal",
  BUTTON_INTERACTIVE_HOVER: "button-interactive-hover",
  BUTTON_INTERACTIVE_FOCUS: "button-interactive-focus",
  BUTTON_INTERACTIVE_ACTIVE: "button-interactive-active",
  // ------------------------------------------------
  BUTTON_PRIMARY_NORMAL: "button-primary-normal",
  BUTTON_PRIMARY_HOVER: "button-primary-hover",
  BUTTON_PRIMARY_FOCUS: "button-primary-focus",
  BUTTON_PRIMARY_ACTIVE: "button-primary-active",
  // ------------------------------------------------
  BUTTON_SECONDARY_NORMAL: "button-secondary-normal",
  BUTTON_SECONDARY_HOVER: "button-secondary-hover",
  BUTTON_SECONDARY_FOCUS: "button-secondary-focus",
  BUTTON_SECONDARY_ACTIVE: "button-secondary-active",
  // ------------------------------------------------
  BUTTON_ACCENT_NORMAL: "button-accent-normal",
  BUTTON_ACCENT_HOVER: "button-accent-hover",
  BUTTON_ACCENT_FOCUS: "button-accent-focus",
  BUTTON_ACCENT_ACTIVE: "button-accent-active",
  // ------------------------------------------------
  BUTTON_GRAY_NORMAL: "button-gray-normal",
  BUTTON_GRAY_HOVER: "button-gray-hover",
  BUTTON_GRAY_FOCUS: "button-gray-focus",
  BUTTON_GRAY_ACTIVE: "button-gray-active",
  // ------------------------------------------------
  BUTTON_ERROR_NORMAL: "button-error-normal",
  BUTTON_ERROR_HOVER: "button-error-hover",
  BUTTON_ERROR_FOCUS: "button-error-focus",
  BUTTON_ERROR_ACTIVE: "button-error-active",
  // ------------------------------------------------
  BUTTON_WARNING_NORMAL: "button-warning-normal",
  BUTTON_WARNING_HOVER: "button-warning-hover",
  BUTTON_WARNING_FOCUS: "button-warning-focus",
  BUTTON_WARNING_ACTIVE: "button-warning-active",
  // ------------------------------------------------
  BUTTON_SUCCESS_NORMAL: "button-success-normal",
  BUTTON_SUCCESS_HOVER: "button-success-hover",
  BUTTON_SUCCESS_FOCUS: "button-success-focus",
  BUTTON_SUCCESS_ACTIVE: "button-success-active",
  // ------------------------------------------------
  BUTTON_WHITE_NORMAL: "button-white-normal",
  BUTTON_WHITE_HOVER: "button-white-hover",
  BUTTON_WHITE_FOCUS: "button-white-focus",
  BUTTON_WHITE_ACTIVE: "button-white-active",
  // ------------------------------------------------

  BUTTON_DISABLED: "button-disabled",
};
